// The tube reload look registry: one World theme look id in, one recipe out
// (R1474, `ui-map-interface.md` §6.3).
//
// One field of a World body names a tube reload look: `reload`, which is
// what an own hull with tubes draws for its tube reload, its rounds and its
// round. The player picks one of eight; this module turns the id into the
// draw code and the figure row, and decides nothing else.
//
// **The arithmetic is not here.** `reload-recipe-kit.ts` holds the context
// type, the stroke floor and every primitive. This module re-exports the
// kit, so an importer takes one name from one place.
//
// **A look that is not built draws the AUTO look**, recipe and row, the rule
// of the hold-fire looks (R1439): `reload-recipes.ts` lists it in
// `PENDING`, and every id a player can pick draws something.
//
// This is a leaf (`leaves.test.ts`).

import { RELOAD_STYLES } from '../gen/balance';
import { RELOAD_LOOKS } from '../gen/presentation';
import type { ReloadRow } from '../gen/presentation';
import type { ReloadRecipe } from './reload-recipe-kit';
import { RECIPES, PENDING } from './reload-recipes';
import { lookRegistry, type Look, type RecipeFile } from './recipe-kit';

export * from './reload-recipe-kit';

/** The World field that names a tube reload look. */
export const RELOAD_FIELD = 'reload';

/** Every look id, in cycle order. Position 0 is the AUTO look (R822). */
export const RELOAD_IDS: readonly string[] = RELOAD_STYLES;

/** The AUTO look: the id every pending look draws. */
export const RELOAD_AUTO = RELOAD_IDS[0];

/** One resolved look: the id asked for, its figures and its draw code. */
export type ReloadLook = Look<ReloadRow, ReloadRecipe>;

/** The one recipe file. */
const FILES: readonly RecipeFile<ReloadRecipe>[] = [{ recipes: RECIPES, pending: PENDING }];

const REGISTRY = lookRegistry<ReloadRow, ReloadRecipe>(
  RELOAD_IDS, FILES, RELOAD_LOOKS as Readonly<Record<string, ReloadRow>>,
);

/** The look of one id, or the AUTO look for an id this build does not hold. */
export const reloadLook: (id: string) => ReloadLook = REGISTRY.look;

/** Which ids the recipe file has built, and which it left pending. */
export const fileHalves = REGISTRY.fileHalves;
